export const setMenuLabel = txt => {
    const txtElems = txt.split('-');
    const label = txtElems.map(el => el === 'the' ? 'the' : (el === 'pi' ? 'PI' : `${el.charAt(0).toUpperCase()}${el.substr(1, el.length)}`));
    return label.join(' ');
}